import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 5.985l.768 2.161 2.071-.984-.984 2.071 2.161.768-2.161.768.984 2.071-2.071-.984L10 14.017l-.768-2.161-2.071.984.984-2.071-2.161-.768 2.161-.768-.984-2.071 2.071.984L10 5.985zM10 3L8.661 6.766 5.051 5.05l1.716 3.61-3.766 1.339 3.766 1.339-1.716 3.61 3.61-1.716L10 16.998l1.339-3.766 3.61 1.716-1.716-3.61 3.766-1.339-3.766-1.339 1.716-3.61-3.61 1.716L10 3z',
  ],
  height: 20,
  width: 20,
});
